<template>
    <div class="o-loader">
    </div>
</template>

<script>/* eslint-disable */

    export default {
        name: 'Asset',
        data: () => ({
            isHidden: true,
            startTime: null
        }),
        methods: {
            show() {
                this.isHidden = false;
                this.startTime = new Date()

                TweenLite.set(this.$el, {
                    zIndex: 500,
                    opacity: 1
                })
            },
            hide() {

                if(this.isHidden) return;

                let timeDiff = (new Date() - this.startTime)/1000
                let delay = timeDiff < .6 ? timeDiff + .4 : .2

                this.isHidden = true

                TweenLite.to(this.$el, .3, {
                    opacity: 0,
                    ease: Power1.easeOut,
                    delay,
                    onComplete: () => {

                        TweenLite.set(this.$el, {
                            clearProps: 'all'
                        })
                    }
                })
            },
        },
    }
</script>
